import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class EditEmergencyEventVm {
	emergencyEventId: number;
	name?: string;
	location?: string;
	latitude?: string;
	longitude?: string;
	eventDate?: Date;
	isActive: boolean;
	strEventDate?: string;
	strIsActive?: string;
	isUpdatedOffline: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'emergencyEventId': new UntypedFormControl(0, [...(validators['emergencyEventId'] ?? []), ...[Validators.required]]),
			'name': new UntypedFormControl(null, [...(validators['name'] ?? []), ...[Validators.maxLength(50), Validators.required]]),
			'location': new UntypedFormControl(null, [...(validators['location'] ?? []), ...[Validators.maxLength(100)]]),
			'latitude': new UntypedFormControl(null, [...(validators['latitude'] ?? []), ...[Validators.maxLength(15)]]),
			'longitude': new UntypedFormControl(null, [...(validators['longitude'] ?? []), ...[Validators.maxLength(15)]]),
			'eventDate': new UntypedFormControl(null, [...(validators['eventDate'] ?? []), ...[]]),
			'isActive': new UntypedFormControl(false, [...(validators['isActive'] ?? []), ...[]]),
			'strEventDate': new UntypedFormControl(null, [...(validators['strEventDate'] ?? []), ...[]]),
			'strIsActive': new UntypedFormControl(null, [...(validators['strIsActive'] ?? []), ...[]]),
			'isUpdatedOffline': new UntypedFormControl(false, [...(validators['isUpdatedOffline'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['name', {"orderId":0,"sortColumn":"name","searchColumn":"name","includeInExcel":true,"exportColumn":null,"displayName":"Name","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['eventDate', {"orderId":1,"sortColumn":"eventDate","searchColumn":"strEventDate","includeInExcel":true,"exportColumn":null,"displayName":"Event Date","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['strIsActive', {"orderId":2,"sortColumn":"strIsActive","searchColumn":"strIsActive","includeInExcel":true,"exportColumn":null,"displayName":"Is Active?","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['delete', {"orderId":3,"sortColumn":"delete","searchColumn":"delete","includeInExcel":true,"exportColumn":null,"displayName":"Delete","isVisible":true,"canSearch":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): EditEmergencyEventVmFromFg {
		return new EditEmergencyEventVmFromFg(fg);
	}
}

export class EditEmergencyEventVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get emergencyEventId(): number {
		return this.fg.get('emergencyEventId').value;
	}
	set emergencyEventId(val) {
		this.fg.get('emergencyEventId').setValue(val);
	}

	get name(): string {
		return this.fg.get('name').value;
	}
	set name(val) {
		this.fg.get('name').setValue(val);
	}

	get location(): string {
		return this.fg.get('location').value;
	}
	set location(val) {
		this.fg.get('location').setValue(val);
	}

	get latitude(): string {
		return this.fg.get('latitude').value;
	}
	set latitude(val) {
		this.fg.get('latitude').setValue(val);
	}

	get longitude(): string {
		return this.fg.get('longitude').value;
	}
	set longitude(val) {
		this.fg.get('longitude').setValue(val);
	}

	get eventDate(): Date {
		return this.fg.get('eventDate').value;
	}
	set eventDate(val) {
		this.fg.get('eventDate').setValue(val);
	}

	get isActive(): boolean {
		return this.fg.get('isActive').value;
	}
	set isActive(val) {
		this.fg.get('isActive').setValue(val);
	}

	get strEventDate(): string {
		return this.fg.get('strEventDate').value;
	}
	set strEventDate(val) {
		this.fg.get('strEventDate').setValue(val);
	}

	get strIsActive(): string {
		return this.fg.get('strIsActive').value;
	}
	set strIsActive(val) {
		this.fg.get('strIsActive').setValue(val);
	}

	get isUpdatedOffline(): boolean {
		return this.fg.get('isUpdatedOffline').value;
	}
	set isUpdatedOffline(val) {
		this.fg.get('isUpdatedOffline').setValue(val);
	}
}
